import {BaseApi} from "@/core/api/base.api";
import {AuthService as authService} from "@/core/service/auth.service";
import {Http} from "@/core/service/http.init";
import _ from "lodash";

class SysAdminApi extends BaseApi {
    #BASE_URL = '/api/v3/systemadmin';

    constructor() {
        super()
    }

    async checkAuth() {
        if(authService.isAccessTokenExpired()){
            await authService.refreshTokens();
        }
        return !authService.isAccessTokenExpired();
    }

    hasSysAdminRole() {
        const data = authService.getAuthData();
        if(!data){
            return false;
        }
        return data.userRole?.includes('SystemAdmin') || false;
    }

    async get({url, params}) {
        let st = Date.now();
        let res;
        try{
            res = await Http.getHttpInstance({auth: true}).get(
                this.#BASE_URL + url,
                {params}
            );
            return res.data.data;
        }finally{
            console.log(`# sysadmin api call (%dms) : %s\r\nurl[%s], params[%o], result[%o]`,
                Date.now() - st, new Date(),
                url, params, res);
        }
    }

    async post({url, params}) {
        if(params){
            const p = new URLSearchParams();
            for(let key in params){
                p.append(key, params[key]);
            }
            params = p;
        }

        let st = Date.now();
        let res;
        try {
            res = await Http.getHttpInstance({auth: true}).post(
                this.#BASE_URL + url,
                params,
                {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    }
                }
            );
            return res.data.data;
        }finally{
            console.log(`# sysadmin api call (%dms) : %s\r\nurl[%s], params[%o], result[%o]`,
                Date.now() - st, new Date(),
                url, params, res);
        }
    }

    createDebounceMethods(methods, waitMs) {
        for(let key in methods){
            const m = methods[key];
            const dm = _.debounce(m, waitMs || 500);
            dm._ori_method = m;
            methods[key] = dm;
        }
        return methods;
    }
}

export const SysAdmin = new SysAdminApi()